export default ({ app }) => {
  if (process.client) {
    let gtmLoaded = false;
    const GTM_ID = 'GTM-W8TSSC';

    const loadGTM = () => {
      if (!gtmLoaded) {
        gtmLoaded = true;

        // Pre-initialize dataLayer to reduce script work
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'user-interaction' });

        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l !== 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', GTM_ID);
      }
    };

    const loadGTMWithStrategy = () => {
      const FALLBACK_DELAY = 2000;

      if ('requestIdleCallback' in window) {
        return requestIdleCallback(() => {
          try {
            loadGTM();
          } catch (error) {
            console.error('Error in loadGTM:', error);
          }
        });
      }

      const loadWithDelay = () => setTimeout(loadGTM, FALLBACK_DELAY);

      return document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', loadWithDelay)
        : loadWithDelay();
    };

    loadGTMWithStrategy();

  }
};